import React, { Component } from 'react'
import Meta from 'components/layout/Meta'
import './404.scss'
class error404 extends Component {
  static title = '中腾信-404';
  state={
    phoneTip: false,
    showModal: false
  }

  componentDidMount(){
    let { router, user } = this.props
  }

  render() {
    return (
  <div className="error-con">
    <Meta location={this.props.location} title="借款资讯-关于我们"/>
     <img src={require('./images/error-404.png')} className="error-img" alt="404" title="404" width="100%" />
      <a href="/" className="error-button">返回首页</a>
      {/* <Breadcrumb breadcrumbs={this.state.breadcrumbs} />
       <div className="wrap product_Detail" id="page_Detail">
       <div className="mg-auto area clearfix">
       <LeftNavigation title={this.state.title} menuList={menuList}/>
       <div className='right'>{this.props.child}</div>
       </div>
       </div>
       <AboutContent child={this.props.children}/> */}
        {/* {this.props.children} */}


      </div>
  )
  }
}
export default error404



// WEBPACK FOOTER //
// ./modules/404/error404.js